/**
 * Written to sessionStorage by the logout effect immediately after it wipes
 * storage and immediately before it hard-navigates to Cognito's end-session
 * endpoint.
 *
 * sessionStorage is scoped to the tab, not to the navigation, so it survives
 * the round trip through Cognito and back to the app. That is the whole reason
 * this marker exists: a silent renew whose response lands after the wipe writes
 * a fresh, valid token blob back into sessionStorage, and the next page load
 * would otherwise re-authenticate the user from it without ever contacting the
 * server. `AuthBootstrapService` checks for the marker and re-wipes before
 * `checkAuth()` gets a chance to read anything.
 */
export const LOGOUT_MARKER_KEY = "logoutInProgress";
